/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import React, { useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Banner, Button, TextStyle, TextField, Icon, Grid } from '@shopify/polaris';
import { DuplicateMinor, CircleTickMajor } from '@shopify/polaris-icons';

import EnableBoostCore from 'src/assets/images/recommendation/enable-boost-core.png';
import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';
import { URL } from 'src/constants/links';

//------------------StoreV1Tab----------------------

const manualCode = `{% comment %} PLEASE DO NOT EDIT THIS FILE {% endcomment %}
{% case type %}
{% when 'product-filter' %}
<div class="boost-sd__product-filter-fallback">
<div class="boost-sd__filter-block"></div></div>
{% when 'recommendation' %}
<div id="boost-sd-widget-{{- widgetId -}}"></div>
{% endcase %}`;
const widgetCode = `{% render 'boost-sd-app', type: 'recommendation', widgetId: 'Replace widgetId here' %}`;

const StoreV1Tab = props => {
  const [enableBoostCoreVideo, setEnableBoostCoreVideo] = useState(false);
  const { i18n, handleOpenBoostCore, enabledBoostCore } = props;
  // copy clip board
  const copyClipBoard = (copyText: string) => {
    try {
      const inputText = document.createElement('input');
      inputText.value = copyText;
      document.body.appendChild(inputText);
      inputText.select();

      document.execCommand('copy');
      document.body.removeChild(inputText);
      showSABToast(i18n.translate('AdminHTML.Common.Action.copied', { t: copyText }), false);
    } catch (error) {}
  };

  return (
    <div className="online-store-v1">
      <div className="step-guide step01">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}>
            <div className="content">
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Label'
                )}
              </TextStyle>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab02.step01_Content_t1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              {enabledBoostCore ? (
                <p>
                  <Icon source={CircleTickMajor} color="success" />
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.enableBoostCore'
                  )}
                </p>
              ) : (
                <Button onClick={handleOpenBoostCore} primary>
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step01_Action'
                  )}
                </Button>
              )}
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <div className="video">
              <div className="BC-Iframe-Container">
                {enableBoostCoreVideo ? (
                  <iframe
                    src={`${URL['Link_V2_Recommendation_ManageWidget_Video']}&start=276&autoplay=1`}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                ) : (
                  <img
                    src={EnableBoostCore}
                    alt="enable-boost-core"
                    style={{ width: '100%' }}
                    onClick={() => setEnableBoostCoreVideo(true)}
                  />
                )}
              </div>
            </div>
          </Grid.Cell>
        </Grid>
      </div>
      <div className="step02">
        <div className="content">
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Label')}
          </TextStyle>
          <div>
            {i18n.translate(
              'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Content',
              {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Content_t1'
                    )}
                  </TextStyle>
                ),
                t2: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Content_t2'
                    )}
                  </TextStyle>
                ),
                t3: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Content_t3'
                    )}
                  </TextStyle>
                ),
                t4: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step02_Content_t4'
                    )}
                  </TextStyle>
                )
              }
            )}
          </div>
          <img
            alt="gif-create-new-snippet"
            src="https://d33v4339jhl8k0.cloudfront.net/docs/assets/590652f62c7d3a057f88b05d/images/643e1e7d7133de139103ec27/file-3d22gAnBkp.gif"
          />
        </div>
        <div className="video"></div>
      </div>
      <div className="step03">
        <div className="content">
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step03_Label')}
          </TextStyle>
          <div>
            {i18n.translate(
              'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step03_Content'
            )}
          </div>
          <div className="html-placeholder">
            <TextField
              name="manualCode"
              id="manualCode"
              value={manualCode}
              multiline={8}
              disabled="disabled"
              suffix={
                <Button icon={DuplicateMinor} plain onClick={() => copyClipBoard(manualCode)} />
              }
            />
          </div>
        </div>
        <div className="video"></div>
      </div>
      <div className="step04">
        <div className="content">
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step04_Label')}
          </TextStyle>
          <div>
            {i18n.translate(
              'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step04_Content01'
            )}
          </div>
          <div className="html-placeholder">
            <TextField
              name="widgetCode"
              id="widgetCode"
              value={widgetCode}
              disabled="disabled"
              suffix={
                <Button icon={DuplicateMinor} plain onClick={() => copyClipBoard(widgetCode)} />
              }
            />
          </div>
          <div>
            {i18n.translate(
              'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.step04_Content02'
            )}
          </div>
        </div>
        <div className="video"></div>
      </div>
      <Banner status="info">
        <p>
          {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.blockContent01')}
        </p>
        <p>
          {i18n.translate('AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.blockContent02')}
        </p>
        <TextStyle variation="strong">
          {`{${i18n.translate(
            'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01.blockContent03'
          )}}`}
        </TextStyle>
      </Banner>
    </div>
  );
};
export default withI18n()(StoreV1Tab);
